import styled from 'styled-components';

export const DefaultContainer = styled.div<{ layout: 'column' | 'row' }>`
  width: 100%;
  display: flex;
  flex-direction: ${({ layout }) => layout};
  text-align: ${({ layout }) => (layout === 'row' ? 'left' : 'center')};
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
`;

export const ImageWrapper = styled.div`
  width: 96px;
  height: 96px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const MessageText = styled.p`
  color: #161d1f;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
`;
